import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#46FA78",
      d: "m26.5 41.5 17.625-17.625-3.5-3.5L26.5 34.5l-7.125-7.125-3.5 3.5zM30 55q-5.187 0-9.75-1.969-4.563-1.968-7.937-5.343T6.969 39.75Q4.999 35.187 5 30t1.969-9.75 5.344-7.937q3.375-3.375 7.937-5.344T30 5t9.75 1.969 7.938 5.344 5.343 7.937Q55.001 24.813 55 30t-1.969 9.75-5.343 7.938q-3.375 3.374-7.938 5.343Q35.187 55.001 30 55m0-5q8.375 0 14.188-5.812Q49.999 38.374 50 30q0-8.374-5.812-14.187Q38.374 10 30 10t-14.187 5.813Q10 21.625 10 30t5.813 14.188T30 50"
    }, null, -1)
  ])))
}
export default { render: render }